import { PaymentMethod, isPaymentMethodDataOneClick } from '@interfaces';

interface PaymentMethodTextsProps {
  paymentMethod: PaymentMethod;
  creditsUsed: string;
}

interface PaymentMethodTextsResponse {
  title: string;
  description: string;
}

export const PaymentMethodTexts = ({
  paymentMethod,
  creditsUsed,
}: PaymentMethodTextsProps): PaymentMethodTextsResponse => {
  const cardInfo = isPaymentMethodDataOneClick(paymentMethod?.data)
    ? `${
        paymentMethod?.data?.creditCardType
      } ${paymentMethod?.data?.last4CardDigits
        .toString()
        .replace(/XXXXXXXXXXXX/g, '•••• ')}`
    : '';

  switch (paymentMethod?.type) {
    case 'ONE_CLICK':
      return {
        title: cardInfo,
        description: 'Webpay OneClick',
      };

    case 'FINTOC':
      return {
        title: 'Directo con tu banco',
        description: 'sin salir de la página',
      };

    case 'MEKI_CREDIT':
      return {
        title: 'Créditos Meki',
        description: creditsUsed,
      };

    case 'BANCO_ESTADO':
      return {
        title: 'Banco Estado',
        description: 'Compraquí',
      };

    case 'INSURANCE':
      return {
        title: 'Seguro',
        description: '',
      };

    default:
      return {
        title: '',
        description: '',
      };
  }
};
